/**
 * Tasks — widget-first Task Manager (2.1).
 * Panels: pages/modules/tasks/panels.tsx
 * Catalog: module-ui-catalog → stejné taby na /core/tasks i node workspace.
 * Záložky oddělují uživatelské / systémové / modulové úlohy (owner_kind).
 */
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('tasks');

export default function TasksPage() {
  return <ModuleWorkspace def={DEF} hideHeader defaultTab='user' />;
}
